// removed by extract-text-webpack-plugin
module.exports = {"cardList":"index__cardList__12nvy","card":"index__card__Plnh3","item":"index__item__1-a6H","extraImg":"index__extraImg__2pT6y","PageFooter":"index__PageFooter__39tyE","_list_link_to":"index___list_link_to__3zgDG","newButton":"index__newButton__J6a4m","cardAvatar":"index__cardAvatar__1q_nI","cardDescription":"index__cardDescription__2GgXm","pageHeaderContent":"index__pageHeaderContent__2xZIC","contentLink":"index__contentLink__208lg"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/User/Settings/index.less
// module id = 1322
// module chunks = 0